import { render, staticRenderFns } from "./CollapsiblePanelLasche.vue?vue&type=template&id=49911a38&scoped=true&"
import script from "./CollapsiblePanelLasche.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePanelLasche.vue?vue&type=script&lang=js&"
import style0 from "./CollapsiblePanelLasche.vue?vue&type=style&index=0&id=49911a38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49911a38",
  null
  
)

export default component.exports